// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ECEmployeeCategory  {
    _originalTypeClassName = "Loom.BO.ECEmployeeCategory";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ECEmployeeCategory.translate = translateService;
}
this.Code = null;
this.Name = null;
this.Description = null;
this._key = this.Code = ""; 
}

static translate: TranslateService;
_key: any;
private _Code:any;
get Code(): any {
    return this._Code;
  }
set Code(value: any) {
    this._Code = value;
    this._key = value;
  }
Name:any;
Description:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Code == null || $this.Code == "";
            }


}